import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils.js"

const buttonVariants = cva(
    "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background",
    {
        variants: {
            variant: {
                // ... previous variants (default, destructive, etc.) remain same
                default: "bg-primary text-primary-foreground hover:bg-primary/90",
                destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
                outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
                secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
                ghost: "hover:bg-accent hover:text-accent-foreground",
                "nav-link": "text-white/90 hover:bg-white/20 hover:text-white rounded-full transition-colors",
                "nav-active": "text-white bg-white/20 hover:bg-white/30 rounded-full shadow-sm",
            },
            size: {
                default: "h-9 px-4 py-2 rounded-md",
                sm: "h-8 rounded-md px-3 text-xs",
                lg: "h-12 rounded-full px-8 text-base",
                icon: "size-9",
                // === NEW SIZE ADDED HERE ===
                // तुमची मागणी: h-10, px-4, आणि Pill shape (rounded-full)
                "nav": "h-10 px-4 rounded-full text-sm font-medium",
                "icon-sm": "size-8",
                "icon-lg": "size-10",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
        <Comp
            className={cn(buttonVariants({ variant, size }), className)}
            ref={ref} // Ref la component var pass kara
            {...props}
        />
    )
})
Button.displayName = "Button" // Component la nav dya

export { Button, buttonVariants }